import { useCallback, useState } from 'react';
import { DeviceDetailCore } from '../useDeviceDetail';

/** The Raw panel: the DeviceDetail payload as the API returns it, with a reload. */
export const useDevicesDetailsRaw = (core: DeviceDetailCore) => {
  const { deviceDetail, reloadDetail } = core;
  const [refreshing, setRefreshing] = useState(false);

  const refresh = useCallback(() => {
    if (refreshing) return;
    setRefreshing(true);
    reloadDetail().finally(() => setRefreshing(false));
  }, [refreshing, reloadDetail]);

  return { deviceDetail, refreshing, refresh };
};
